export default "__VITE_ASSET__rJUqxatI__"